import React from 'react'

import { AlignItems, Box, Display, Heading4, Join, Space } from '@gousto-internal/citrus-react'

import type { RecipeTagGroups } from '@library/api-menu-experience'

import { TagPill } from './TagPill'

type RecipeAttributesProps = {
  tagGroups?: RecipeTagGroups
  loading: boolean
}

export const RecipeAttributes = ({ tagGroups, loading }: RecipeAttributesProps) => {
  if (!tagGroups?.general?.length) {
    return null
  }

  return (
    <Join with={<Space size={2} />}>
      <Heading4>Recipe details</Heading4>
      <Box
        alignItems={AlignItems.FlexStart}
        wrap
        data-testid="RecipeAttributesPills"
        display={Display.Flex}
      >
        {!loading &&
          tagGroups?.general?.map((tag) => (
            <TagPill key={tag.type} type={tag.type} text={tag.text} />
          ))}
      </Box>
    </Join>
  )
}
